import json from './json'

export const jsonService = json
